// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2gRXj","tab":"ProcedureTabs_tab__gUYxg"};